@if (!accountCreated$()) {
  <div class="partner-form">
    <form class="row form-group" #partnerForm="ngForm">
      <!-- SLG Mode: Show email field -->
      @if (isSLGMode) {
        <div class="col-md-12 calio-pc-reseller-form-group mb-2">
          <label class="calio-reseller-label" for="email">
            {{ 'create_partner_component.email_label' | translate | addRequired }}
          </label>
          <input
            type="email"
            class="reseller-form-input"
            id="email"
            name="email"
            autocomplete="email"
            [(ngModel)]="partnerFormModel.email"
            #emailField="ngModel"
            [ngClass]="{ 'is-invalid': (emailField.touched && emailField.invalid) || emailError$() }"
            required="true"
            email="true"
            [maxlength]="255"
          />
          <!-- Show only one error at a time: API errors take priority -->
          @if (emailError$() === 'unique') {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'error_messages.email_error' | translate }}
            </div>
          } @else if (emailError$() === 'banned') {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'error_messages.email_banned_domains' | translate }}
            </div>
          } @else if (emailError$() === 'disposable') {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'error_messages.email_disposable' | translate }}
            </div>
          } @else if (emailError$() === 'free_provider') {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'error_messages.email_free_provider' | translate }}
            </div>
          } @else if (emailError$() === 'domain_blocked') {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'error_messages.email_domain_blocked' | translate }}
            </div>
          } @else if (emailField.touched && emailField.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (emailField.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              } @else if (emailField.errors.email) {
                {{ 'error_messages.email_error_message' | translate }}
              }
            </div>
          }
        </div>
      }
      <!-- PLG Mode: Show all fields -->
      @if (!isSLGMode) {
        <!-- first name -->
        <div class="col-sm-6 calio-pc-reseller-form-group mb-2">
          <label class="calio-reseller-label" for="prename">
            {{ 'create_partner_component.prename_label' | translate | addRequired }}
          </label>
          <input
            type="text"
            class="reseller-form-input"
            id="prename"
            name="prename"
            autocomplete="given-name"
            [(ngModel)]="partnerFormModel.prename"
            #prename="ngModel"
            [ngClass]="{ 'is-invalid': prename.touched && prename.invalid }"
            required="true"
            [maxlength]="255"
          />
          @if (prename.touched && prename.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (prename.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              }
            </div>
          }
        </div>
        <!-- last name -->
        <div class="col-sm-6 calio-pc-reseller-form-group mb-2">
          <label class="calio-reseller-label" for="lastname">
            {{ 'create_partner_component.lastname_label' | translate | addRequired }}
          </label>
          <input
            type="text"
            class="reseller-form-input"
            id="lastname"
            name="lastname"
            autocomplete="family-name"
            [(ngModel)]="partnerFormModel.lastname"
            #lastname="ngModel"
            [ngClass]="{ 'is-invalid': lastname.touched && lastname.invalid }"
            required="true"
            [maxlength]="255"
          />
          @if (lastname.touched && lastname.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (lastname.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              }
            </div>
          }
        </div>
        <!-- Company name -->
        <div class="col-sm-6 calio-pc-reseller-form-group mb-2">
          <label class="calio-reseller-label" for="name">
            {{ 'create_partner_component.company_name' | translate | addRequired }}
          </label>
          <input
            type="text"
            class="reseller-form-input"
            id="name"
            name="name"
            autocomplete="organization"
            [(ngModel)]="partnerFormModel.name"
            #name="ngModel" [ngClass]="{ 'is-invalid': name.touched && name.invalid }"
            required="true"
            [maxlength]="255"
          />
          @if (name.touched && name.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (name.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              }
            </div>
          }
        </div>
        <!-- Job title -->
        <div class="col-sm-6 calio-pc-reseller-form-group mb-2">
          <label class="calio-reseller-label" for="job_title">
            {{ 'create_partner_component.job_title' | translate | addRequired }}
          </label>
          <input
            type="text"
            class="reseller-form-input"
            id="job_title"
            name="job_title"
            autocomplete="organization-title"
            [(ngModel)]="partnerFormModel.job_title"
            #job_title="ngModel"
            required="true"
            [ngClass]="{ 'is-invalid': job_title.touched && job_title.invalid }"
            [maxlength]="255"
          />
          @if (job_title.touched && job_title.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (job_title.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              }
            </div>
          }
        </div>
        <!-- Industry name -->
        <div class="col-sm-6 custom-ng-select mb-2">
          <label class="calio-reseller-label mb-2" for="industry">
            {{ 'create_partner_component.industry' | translate | addRequired }}
          </label>
          <ng-select
            id="industry"
            name="industry"
            [(ngModel)]="partnerFormModel.industry"
            #industry="ngModel"
            [ngClass]="{ 'is-invalid': industry.touched && industry.invalid }"
            required="true"
          >
            @for (industry of (industryList | staticTranslationSort : 'key'); track industry) {
              <ng-option [value]="industry.value">
                {{ industry.key | translate }}
              </ng-option>
            }
          </ng-select>
          @if (industry.touched && industry.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (industry.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              }
            </div>
          }
        </div>
        <!-- Company Size -->
        <div class="col-sm-6 custom-ng-select mb-2">
          <label class="calio-reseller-label mb-2" for="companySize">
            {{ 'create_partner_component.company_size' | translate | addRequired }}
          </label>
          <ng-select
            id="companySize"
            name="companySize"
            [(ngModel)]="partnerFormModel.company_size"
            #companysize="ngModel"
            [ngClass]="{ 'is-invalid': companysize.touched && companysize.invalid }"
            required="true"
          >
            @for (size of companySize; track size) {
              <ng-option [value]="size.value">
                {{ 'create_partner_component.company_size_options.' + size.key | translate }}
              </ng-option>
            }
          </ng-select>
          @if (companysize.touched && companysize.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (companysize.errors.required) {
                {{ 'error_messages.required_error_message' | translate }}
              }
            </div>
          }
        </div>
      }
      <!-- Password - shown for both PLG and SLG -->
      <div class="calio-pc-reseller-form-group mb-2" [class.col-md-6]="!isSLGMode" [class.col-md-12]="isSLGMode">
        <div class="calio-pc-reseller-form-group">
          <label class="calio-reseller-label" for="password">
            {{ 'create_partner_component.password_label' | translate | addRequired }}
          </label>
          <input
            type="password"
            class="reseller-form-input"
            id="password"
            name="password"
            autocomplete="new-password"
            [(ngModel)]="partnerFormModel.password"
            #password="ngModel"
            [ngClass]="{ 'is-invalid': password.touched && password.invalid }"
            required="true" #passwordWithValidation
            (focus)="showPasswordDetails = true"
            (blur)="showPasswordDetails = false"
            (keyup)="showPasswordDetails = true"
            minlength="8"
            [maxlength]="255"
          />
          <app-password-strength-bar
            [passwordToCheck]="partnerFormModel.password"
            (passwordValidatedEvent)="validatePassword($event)"
            aria-hidden="true"
          />
          <!-- Password rules conveyed as text (not colour alone) so the -->
          <!-- requirements are clear up front; the neutral hint escalates -->
          <!-- to the invalid-feedback style only once the field is touched. -->
          @if (password.touched && !isPasswordValid$() && partnerFormModel.password) {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'create_partner_component.password_strength_error' | translate }}
            </div>
          } @else if (!isPasswordValid$() && (showPasswordDetails || partnerFormModel.password)) {
            <div class="small text-muted mt-1">
              {{ 'create_partner_component.password_strength_error' | translate }}
            </div>
          }
          @if (password.touched && password.errors?.required) {
            <div class="calio-pc-reseller-invalid-feedback">
              {{ 'error_messages.required_error_message' | translate }}
            </div>
          }
        </div>
      </div>
      <!-- Phone - PLG always; SLG when the brand requires mobile verification
           (require_mobile_confirmation) OR the backend already answered mobile.required. -->
      @if (!isSLGMode || requireMobileConfirmation() || mobileRequired) {
        <div class="col-sm-6 calio-pc-reseller-form-group mb-2" [class.col-md-12]="isSLGMode">
          <label class="calio-reseller-label" for="phone">
            {{ 'create_partner_component.phone' | translate | addRequired }}
          </label>
          <div class="mt-2">
            <app-calio-tel-input
              name="phone"
              [(ngModel)]="partnerFormModel.phone"
              #phone="ngModel"
              cssClass="reseller-form-input"
              required="true"
              [onlyCountries]="allowedCountries()"
              [ngClass]="{ 'is-invalid': phone?.touched && phone?.errors }"
            />
          </div>
          @if (phone?.touched && phone?.invalid) {
            <div class="calio-pc-reseller-invalid-feedback">
              @if (phone?.errors?.required) {
                {{ 'error_messages.required_error_message' | translate }}
              } @else if (phone?.errors?.invalidNumber) {
                {{ 'create_partner_component.invalid_phone_number' | translate }}
              }
            </div>
          }
        </div>
      }
      
      @if (!accountCreated$()) {
      <div class="col-md-12 mb-1 calio-pc-button-container">
        <button
          id="register_company_data"
          type="submit"
          [disabled]="partnerForm.invalid || !isPasswordValid$() || showLoader$()"
          class="calio-pc-reseller-button signin-button"
          (click)="savePartnerData()"
        >
          @if (showText$()) {
            <span>
              {{ 'create_partner_component.create_account' | translate }}
            </span>
          }
          @if (showLoader$()) {
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          }
        </button>
      </div>
      }
      <div class="fs-6 m-2 text-center free-account-text">
        {{ 'create_partner_component.free_account' | translate }}
      </div>

      @if (isSLGMode) {
        <div class="text-center mt-3">
          {{ 'create_partner_component.login' | translate }}&nbsp;
          <a class="forgot-password" href="{{ redirectUrl }}" target="_blank">
            {{ 'create_partner_component.login_link' | translate }}
          </a>
        </div>
      }
    </form>
  </div>
}